<template>
  <div class="network">
    <button v-on:click="add_node">push</button>
  <div id="cy">
</div>
</div>
</template>

<script>
// import NoticeItem from '@/components/Notice/NoticeItem'
// import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import OrganizationItem from '@/components/People/OrganizationItem'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
import drag from '@branu-jp/v-drag'
import VueDragscroll from 'vue-dragscroll'
import NetWorkContent from '@/components/Okr/NetWorkContent'
Vue.use(VueDragscroll)
var cytoscape = require('cytoscape')
export default {
  name: 'NetWork',
  mixedins: [validationMixin],
  components: {
    // NoticeItem
    OrganizationItem,
    ManageWrapperComponent,
    NetWorkContent
  },
  directives: {
    drag
  },
  data: function () {
    return {
      tag: 'ManageGroupEdit',
      open: false,
      x1: 100,
      checkedUsers: [],
      checkedGroup: [],
      deleteUsers: {},
      groupUsers: {},
      groups: {},
      searchText: '',
      groupName: '',
      oldMembers: [],
      groupOwnerId: '',
      ownerEdit: false,
      id: this.$route.params.id,
      isRegistering: false,
      showModal: false,
      checkOrganization: '',
      // parentOrganization
      checkedOrganization: '',
      childGroups: {},
      depth: 1,
      checkedDepth: 0,
      elements: [
        { // node a
          data: { id: 'a' }
        }, { // node b
          data: { id: 'b' }
        }, { // edge ab
          data: { id: 'ab', source: 'a', target: 'b' }
        }
      ],
      config: {
        style: [
          {
            selector: 'node',
            style: {
              'background-color': '#666',
              'label': 'data(id)'
            }
          }, {
            selector: 'edge',
            style: {
              'width': 3,
              'line-color': '#ccc',
              'target-arrow-color': '#ccc',
              'target-arrow-shape': 'triangle'
            }
          }
        ],
        layout: {
          name: 'grid',
          rows: 1
        }
      }
    }
  },
  validations: {
    groupName: {
      required
    }
  },
  computed: {

  },
  updated: function () {
    console.log('updated')
  },
  mounted: function () {
    this.view_init()
    console.log('cy', this.cy)
  },
  methods: {
    view_init: function () {
      console.log('start')
      this.cy = cytoscape(
        {
          container: document.getElementById('cy'),
          boxSelectionEnabled: false,
          autounselectify: true,
          style: cytoscape.stylesheet()
            .selector('node')
            .css({
              'height': 80,
              'width': 80,
              'background-fit': 'cover',
              'border-color': '#000',
              'border-width': 3,
              'border-opacity': 0.5,
              'content': 'data(name)',
              'text-valign': 'center'
            })
            .selector('edge')
            .css({
              'width': 6,
              'target-arrow-shape': 'triangle',
              'line-color': '#ffaaaa',
              'target-arrow-color': '#ffaaaa',
              'curve-style': 'bezier'
            }),
          elements: {
            nodes: [
              { data: { id: 'cat', label: 'cat' } },
              { data: { id: 'bird' } },
              { data: { id: 'ladybug' } },
              { data: { id: 'aphid' } },
              { data: { id: 'rose' } },
              { data: { id: 'grasshopper' } },
              { data: { id: 'plant' } },
              { data: { id: 'wheat' } }
            ],
            edges: [
              { data: { source: 'cat', target: 'bird' } },
              { data: { source: 'bird', target: 'ladybug' } },
              { data: { source: 'bird', target: 'grasshopper' } },
              { data: { source: 'grasshopper', target: 'plant' } },
              { data: { source: 'grasshopper', target: 'wheat' } },
              { data: { source: 'ladybug', target: 'aphid' } },
              { data: { source: 'aphid', target: 'rose' } }
            ]
          },
          layout: {
            name: 'breadthfirst',
            directed: true,
            padding: 10
          }
        }
      )
    },
    add_node: function (newId, targetId) {
      this.cy.add([
        { 'group': 'nodes', data: { 'id': newId }, position: { x: 300, y: 200 } },
        {'group': 'edges', data: {'id': 'edge' + this.count, 'source': newId, 'target': targetId}}
      ])
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.ibox-child
span.crown-mark {
  top: 1.0rem;
  left: -1.8rem;
    /* text-shadow: 16px -6px black; */
}
.border-none {
  border: none;
}
.parentPath {
  margin-top: 8px;
}

.grab-bing {
cursor : -webkit-grab;
cursor : -moz-grab;
cursor : -o-grab;
cursor : grab;
}
.grab-bing:active {
cursor : -webkit-grabbing;
cursor : -moz-grabbing;
cursor : -o-grabbing;
cursor : grabbing;
}
#box {
    position: relative;
    width: 60%;
    height: 300px;
    overflow: hidden;
    border: 1px solid #000;
    padding:10px;
  }
.content {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  position: relative;
  text-align: center;
}
.content2 {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  position: relative;
  text-align: center;
}
#cy {
  height: 300px;
  width: 600px;
  border: 0.5px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/Okr/netWorkContentSVG.vue